import { render, staticRenderFns } from "./zoning-index.vue?vue&type=template&id=4a2a23dc"
import script from "./zoning-index.vue?vue&type=script&lang=js"
export * from "./zoning-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports